import { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from './index';
import Icon from './Icon';

export default function PasswordInput({ label, disabled, style, id, ...props }) {
  const [visible, setVisible] = useState(false);
  const generatedId = useId();
  const fieldId = id || generatedId;
  const visibilityLabel = visible ? 'Ocultar senha' : 'Mostrar senha';
  return <Input {...props} id={fieldId} label={label} disabled={disabled} type={visible ? 'text' : 'password'} style={{ ...style, paddingRight: 52 }}
    endAdornment={<button type="button" className="rf-password-toggle" disabled={disabled}
      aria-label={visibilityLabel} title={visibilityLabel} aria-pressed={visible} aria-controls={fieldId} aria-describedby={`${fieldId}-visibility`}
      onClick={() => setVisible(value => !value)}><Icon name={visible ? 'eye-off' : 'eye'} size={18} /><span id={`${fieldId}-visibility`} className="rf-visually-hidden">{label}</span></button>} />;
}
PasswordInput.propTypes = { label: PropTypes.string.isRequired, disabled: PropTypes.bool, style: PropTypes.object, id: PropTypes.string };
